var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyrightIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 10.4228C3.33337 6.74087 6.31814 3.7561 10 3.7561C13.6819 3.7561 16.6667 6.74087 16.6667 10.4228C16.6667 14.1047 13.6819 17.0894 10 17.0894C6.31814 17.0894 3.33337 14.1047 3.33337 10.4228Z",
    stroke: "#1A1919",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 12.8675C10.9834 13.0103 10.5969 13.0894 10.1905 13.0894C8.61256 13.0894 7.33337 11.8955 7.33337 10.4228C7.33337 8.95001 8.61256 7.7561 10.1905 7.7561C10.5969 7.7561 10.9834 7.83528 11.3334 7.97799",
    stroke: "#1A1919",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyrightIco);
export default __webpack_public_path__ + "static/media/copyright-ico.27dfbcb974a4c817ec5938e39deccb10.svg";
export { ForwardRef as ReactComponent };